import React, { useContext, useEffect, useState } from "react";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import SelectErp from "../../../../components/basics/SelectErp";
import TextFieldErp from "../../../../components/basics/TextFieldErp";
import Chip from "../../../../components/basics/Chip";

import { PrescricaoContext } from "../contexts/PrescricaoContext";
import usePrescricaoController from "../controllers/PrescricaoController";
import { HeaderAccordion } from "../styles/Prescricao";
import { QueryParamsContext } from "../../../../context/QueryParamsContext";
import { findLenteTipo } from "../../../../repositories/qerpapi/erp/optica/v1/LenteTipoRepository";
import { findLenteTratamento } from "../../../../repositories/qerpapi/erp/optica/v1/LenteTratamentoRepository";

// falta tudo, selecioanar um produto Lente que irá compor a Prescricao
// trara o valor cadastrado mas poderá ser alterado na prescrição

const AccordionPrescricaoCadastroLente = ({ ...props }) => {
  const { queryParams } = useContext(QueryParamsContext);
  const { handleChangeOpenAcordion } = usePrescricaoController();
  const {
    expanded,
    lenteTipoSelected,
    setLenteTipoSelected,
    lenteTratamentoSelected,
    setLenteTratamentoSelected,
    lenteReflexoSelected,
    setLenteReflexoSelected,
    lenteRiscoSelected,
    setLenteRiscoSelected,
    lenteODEsf,
    setLenteODEsf,
    lenteODCili,
    setLenteODCili,
    lenteODEixo,
    setLenteODEixo,
    lenteODDNP,
    setLenteODDNP,
    lenteOEEsf,
    setLenteOEEsf,
    lenteOECili,
    setLenteOECili,
    lenteOEEixo,
    setLenteOEEixo,
    lenteOEDNP,
    setLenteOEDNP,
    lenteAdicao,
    setLenteAdicao,
    lenteAltura,
    setLenteAltura,
    lenteSelected,
    setLenteSelected,
    autoVariais,
  } = useContext(PrescricaoContext);

  const [lenteTipoList, setLenteTipoList] = useState([]);
  const [loadingTipo, setLoadingTipo] = useState(false);
  const [lenteTratamentoList, setLenteTratamentoList] = useState([]);
  const [loadingTratamento, setLoadingTratamento] = useState(false);
  const [valorODDNP, setValorODDNP] = useState(22.5);
  const [valorOEDNP, setValorOEDNP] = useState(22.5);
  const [valorAltura, setValorAltura] = useState(15);
  const [valorAdicao, setValorAdicao] = useState(0.5);

  const listAjuste = [
    {
      label: "Par",
      id: "P",
    },
    {
      label: "Direita",
      id: "D",
    },
    {
      label: "Esquerda",
      id: "E",
    },
  ];

  const listOptions = [
    {
      label: "SIM",
      id: "S",
    },
    {
      label: "NÃO",
      id: "N",
    },
  ];

  useEffect(() => {
    (async () => {
      try {
        setLoadingTipo(true);
        const resultTipo = await findLenteTipo({
          empresa_cnpj: queryParams?.empresa_cnpj || "",
        });
        if (resultTipo.success) setLenteTipoList(resultTipo.data);
      } catch (error) {
      } finally {
        setLoadingTipo(false);
      }
    })();
  }, [queryParams?.empresa_cnpj]);

  useEffect(() => {
    if (!lenteTipoList.length || !autoVariais.tipoLente) return;

    setLenteTipoSelected(
      lenteTipoList.find((type) => type.descricao === autoVariais?.tipoLente) ||
        null
    );
  }, [lenteTipoList, autoVariais, setLenteTipoSelected]);

  useEffect(() => {
    if (lenteOEDNP > 0) {
      setValorOEDNP(0.5);
    }
  }, [lenteOEDNP]);

  useEffect(() => {
    if (lenteODDNP > 0) {
      setValorODDNP(0.5);
    }
  }, [lenteODDNP]);

  useEffect(() => {
    if (lenteAltura > 0) {
      if (lenteAltura > 34 || lenteAltura < 15) {
        setValorAltura(15);
        setLenteAltura(0);
      } else {
        setValorAltura(0.5);
      }
    }
  }, [lenteAltura, setLenteAltura]);

  useEffect(() => {
    if (lenteAdicao > 0) {
      if (lenteAdicao > 4 || lenteAdicao < 0.5) {
        setLenteAdicao(0);
        setValorAdicao(0.5);
      } else {
        setValorAdicao(0.25);
      }
    }
  }, [lenteAdicao, setLenteAdicao]);

  useEffect(() => {
    (async () => {
      try {
        setLoadingTratamento(true);
        const resultTipo = await findLenteTratamento({
          empresa_cnpj: queryParams?.empresa_cnpj || "",
        });
        if (resultTipo.success) setLenteTratamentoList(resultTipo.data);
      } catch (error) {
      } finally {
        setLoadingTratamento(false);
      }
    })();
  }, [queryParams?.empresa_cnpj]);

  useEffect(() => {
    if (!lenteTratamentoList.length || !autoVariais.tratamentoLente) return;

    setLenteTratamentoSelected(
      lenteTratamentoList.find(
        (type) => type.descricao === autoVariais?.tratamentoLente
      ) || null
    );
  }, [lenteTratamentoList, autoVariais, setLenteTratamentoSelected]);

  return (
    <>
      <Grid item xs={12}>
        <Accordion expanded={expanded.registerLens || false}>
          <AccordionSummary
            expandIcon={
              <ExpandMoreIcon
                onClick={() => handleChangeOpenAcordion("registerLens")}
              />
            }
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <HeaderAccordion>
              <Grid container spacing={1} alignItems="center">
                <Grid
                  item
                  xs
                  onClick={() => handleChangeOpenAcordion("registerLens")}
                >
                  <Chip label="LENTE" bgcolor={"default"} />
                </Grid>
              </Grid>
            </HeaderAccordion>
          </AccordionSummary>

          <AccordionDetails>
            <Grid container spacing={2}>
              <Grid item lg={3} md={3} sm={6} xs={4}>
                <SelectErp
                  id="lenteTipo"
                  label="Lentes"
                  descriptionField="label"
                  optionsList={listAjuste}
                  value={lenteSelected}
                  setValue={setLenteSelected}
                />
              </Grid>
              <Grid item xs={12}></Grid>
              <Grid item lg={2} md={3} sm={6} xs={4}>
                <Chip label="O.D." bgcolor={"default"} />
              </Grid>
              <Grid item lg={2} md={3} sm={6} xs={4}>
                <TextFieldErp
                  type="number"
                  label="Esférico"
                  disabled={lenteSelected?.id === "E"}
                  value={lenteODEsf}
                  setValue={setLenteODEsf}
                  InputProps={{ step: 0.25 }}
                ></TextFieldErp>
              </Grid>
              <Grid item lg={2} md={3} sm={6} xs={4}>
                <TextFieldErp
                  type="number"
                  label="Cilíndrico"
                  disabled={lenteSelected?.id === "E"}
                  value={lenteODCili}
                  setValue={setLenteODCili}
                  InputProps={{ max: 0, step: 0.25 }}
                ></TextFieldErp>
              </Grid>
              <Grid item lg={3} md={3} sm={6} xs={4}>
                <TextFieldErp
                  type="number"
                  label="Eixo"
                  disabled={lenteSelected?.id === "E"}
                  decimals={0}
                  value={lenteODEixo}
                  setValue={setLenteODEixo}
                  InputProps={{ step: 0.1 }}
                ></TextFieldErp>
              </Grid>
              <Grid item lg={3} md={3} sm={6} xs={4}>
                <TextFieldErp
                  type="number"
                  label="DNP"
                  disabled={lenteSelected?.id === "E"}
                  value={lenteODDNP}
                  setValue={setLenteODDNP}
                  InputProps={{ min: 0, step: valorODDNP }}
                ></TextFieldErp>
              </Grid>
              <Grid item lg={2} md={3} sm={6} xs={4}>
                <Chip label="O.E." bgcolor={"default"} />
              </Grid>
              <Grid item lg={2} md={3} sm={6} xs={4}>
                <TextFieldErp
                  type="number"
                  label="Esférico"
                  disabled={lenteSelected?.id === "D"}
                  value={lenteOEEsf}
                  setValue={setLenteOEEsf}
                  InputProps={{ step: 0.25 }}
                ></TextFieldErp>
              </Grid>
              <Grid item lg={2} md={3} sm={6} xs={4}>
                <TextFieldErp
                  type="number"
                  label="Cilíndrico"
                  disabled={lenteSelected?.id === "D"}
                  value={lenteOECili}
                  setValue={setLenteOECili}
                  InputProps={{ max: 0, step: 0.25 }}
                ></TextFieldErp>
              </Grid>
              <Grid item lg={3} md={3} sm={6} xs={4}>
                <TextFieldErp
                  type="number"
                  label="Eixo"
                  disabled={lenteSelected?.id === "D"}
                  decimals={0}
                  value={lenteOEEixo}
                  setValue={setLenteOEEixo}
                  InputProps={{ min: 0, step: 0.1 }}
                ></TextFieldErp>
              </Grid>
              <Grid item lg={3} md={3} sm={6} xs={4}>
                <TextFieldErp
                  type="number"
                  label="DNP"
                  disabled={lenteSelected?.id === "D"}
                  value={lenteOEDNP}
                  setValue={setLenteOEDNP}
                  InputProps={{ min: 0, step: valorOEDNP }}
                ></TextFieldErp>
              </Grid>
              <Grid item xs={2}></Grid>
              <Grid item lg={3} md={3} sm={6} xs={4}>
                <TextFieldErp
                  type="number"
                  label="Adição"
                  value={lenteAdicao}
                  setValue={setLenteAdicao}
                  InputProps={{ min: 0, step: valorAdicao }}
                ></TextFieldErp>
              </Grid>
              <Grid item lg={3} md={3} sm={6} xs={4}>
                <TextFieldErp
                  type="number"
                  label="Altura"
                  decimals={0}
                  value={lenteAltura}
                  setValue={setLenteAltura}
                  InputProps={{ min: 0, step: valorAltura }}
                ></TextFieldErp>
              </Grid>
              <Grid item lg={5} md={3} sm={6} xs={4}>
                <SelectErp
                  id="tipo"
                  label="Tipo de Lente"
                  descriptionField="descricao"
                  value={lenteTipoSelected}
                  setValue={setLenteTipoSelected}
                  optionsList={lenteTipoList}
                  loading={loadingTipo}
                />
              </Grid>
              <Grid item lg={5} md={3} sm={6} xs={4}>
                <SelectErp
                  id="tratamento"
                  label="Tratamento da Lente"
                  descriptionField="descricao"
                  value={lenteTratamentoSelected}
                  setValue={setLenteTratamentoSelected}
                  optionsList={lenteTratamentoList}
                  loading={loadingTratamento}
                />
              </Grid>
              <Grid item lg={4} md={3} sm={6} xs={4}>
                <SelectErp
                  id="reflexo"
                  label="Anti-Reflexo"
                  descriptionField="label"
                  optionsList={listOptions}
                  value={lenteReflexoSelected}
                  setValue={setLenteReflexoSelected}
                />
              </Grid>
              <Grid item lg={4} md={3} sm={6} xs={4}>
                <SelectErp
                  id="risco"
                  label="Anti-Risco"
                  descriptionField="label"
                  optionsList={listOptions}
                  value={lenteRiscoSelected}
                  setValue={setLenteRiscoSelected}
                />
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Grid>
    </>
  );
};

export { AccordionPrescricaoCadastroLente };
